import { useEffect, useState } from "react";
import api from "@/lib/api";

// Generic CMS content reader. Stores {key, value} via /api/content/{key}.
const TTL = 60_000; // consider a cached value fresh for 60s (kills duplicate fetches per page load)
const caches = {}; // key -> { value, ts }
const inflight = {}; // key -> shared in-flight promise

// Drop a cached content key so the next read re-fetches (used after an admin save).
export function invalidateContent(key) {
  delete caches[key];
}

export function useContent(key, defaults = {}) {
  const [v, setV] = useState(caches[key]?.value || defaults);
  useEffect(() => {
    const cached = caches[key];
    if (cached) {
      setV(cached.value);
      if (Date.now() - cached.ts < TTL) return; // fresh — skip the network round-trip
    }
    // Dedupe concurrent mounts: share a single in-flight request per key.
    const req =
      inflight[key] ||
      (inflight[key] = api.get(`/content/${key}`).finally(() => {
        delete inflight[key];
      }));
    req
      .then((r) => {
        if (r.data?.value) {
          caches[key] = { value: { ...defaults, ...r.data.value }, ts: Date.now() };
          setV(caches[key].value);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return v;
}
